<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h3 style="text-align: center">ผู้ถูกหักภาษี</h3>
            <div class="row">
                    <label class="col-2 col-form-label text-capitalize text-right">ชื่อ</label>
                    <div class="col-4">
                        <input type="text" class="form-control w-100" v-model="form.name">
                    </div>
                    <label class="col-2 col-form-label text-capitalize text-right">เลขภาษี</label>
                    <div class="col-4">
                        <input type="text" class="form-control w-100" v-model="form.tax">
                    </div>
            </div>
            <div class="row mt-5">
                <div class="form-group col-12 row">
                    <label class="col-2 col-form-label text-capitalize text-right">ที่อยู่</label>
                    <div class="col-10">
                        <textarea class="form-control" v-model="form.address">
                    </textarea>
                    </div>
                </div>
            </div>
            <div class="form-group col-12 row">
                <label class="col-2 col-form-label text-capitalize text-right">ประเภทเงินได้</label>
                <div class="col-4">
                    <input type="text" class="form-control w-100" v-model="form.tax_type">
                </div>
            </div>
            <div class="row my-5">
                <div class="col-6 offset-1 text-center">
                    <button @click="save()"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        บันทึก
                    </button>
                </div>
            </div>
        </div>

        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import VuePagination from "../../Pagination";
    import { domain } from "../../../util/Constants";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'
    import Loading from "../../Utility/Loading";
    import MaskedInput from 'vue-masked-input'
    export default {
        name: "tax-customer-form",
        components:{
            Loading,
            Multiselect,
            VuePagination,
            DatePicker,
            MaskedInput,
        },
        data(){
          return {
              msg : '',
              status_loading : 1,
              form : {
                  'id' : '',
                  'name' : '',
                  'tax' : '',
                  'address' : '',
                  'tax_type' : '',
              },
              items: [
                  {
                      text: "หักภาษี ณ ที่จ่าย",
                      to: { name: "tax-customer-info" }
                  },
                  {
                      text: "สร้าง",
                      active: true
                  }
              ],
          }
        },
        created(){
            if (this.$route.params.id != null){
                this.$store.dispatch("TaxInvoice/showTaxCustomer",this.$route.params.id).then(res=>{
                    this.form = {
                        'id' : res.data.id,
                        'name' : res.data.name,
                        'tax' : res.data.tax_number,
                        'address' : res.data.address,
                        'tax_type' : res.data.tax_type,
                    };
                });
            }
        },
        computed:{
            // ...mapState({
            //     form :state=>{
            //         return state.TaxInvoice.form_tax
            //     },
            // }),
            // calculateVAT(){
                // if(this.TaxVAT.value == 1){
                //     if(this.form.invoice){
                //         this.form.total = parseFloat(this.form.invoice.total).toFixed(2);
                //     }
                //     this.form.tax = this.form.total * (7/107)
                //     this.form.tax = this.form.tax.toFixed(2);
                // }else{
                //     if(this.form.invoice){
                //         this.form.total = parseFloat(this.form.invoice.total).toFixed(2);
                //     }
                //     this.form.tax = this.form.total * 0.07;
                //     this.form.tax = this.form.tax.toFixed(2);
                // }
                // return this.form.tax;
            // },
        },
        methods:{
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            save(){
                if (this.form.name)
                    this.$store.dispatch("TaxInvoice/createTaxCustomer",this.form).then(()=>{
                        this.$router.push('/accounting/tax-customer-info')
                    });
                else
                    alert('กรุณาใส่ชื่อผู้ถูกหักภาษี')
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: lightgray;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
    .total-padding{
        padding-right: 20px;
        text-align: right;
    }
    .pad-left-1{
        padding-left: 3%;
    }
    .pad-left-2{
        padding-left: 6%;
    }
    .pad-left-3{
        padding-left: 9%;
    }
</style>
